module.exports = __webpack_public_path__ + "static/img/c-sw.f4d4eb0a.png";